import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ApplicationModulesActions from './application-modules.actions';
import { ArkikAlertService } from 'src/app/shared/components/arkik-alert/arkik-alert.service';
import { TranslationService } from 'src/app/core/services/common/translation.service';
import { map, switchMap, catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectApplicationModulesByKey } from './application-modules.selectors';
import { ApplicationModulesStoreService } from './application-modules.service';

@Injectable()
export class ApplicationModulesEffects {
  constructor(
    private actions$: Actions,
    private modulesService: ApplicationModulesStoreService,
    private alert: ArkikAlertService,
    private translation: TranslationService,
    private store: Store,
  ) {}

  loadApplicationModules$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ApplicationModulesActions.loadApplicationModules),
      switchMap(({ payload }) => {
        const applicationGuid = payload.ApplicationGuid;
        const key = applicationGuid;
        return this.store.select(selectApplicationModulesByKey(applicationGuid)).pipe(
          take(1),
          switchMap((modules) => {
            if (modules) {
              return of(ApplicationModulesActions.loadApplicationModulesSuccess({ key, modules }));
            }
            return this.modulesService.getApplicationModules(payload).pipe(
              map((response) => ApplicationModulesActions.loadApplicationModulesSuccess({ key, modules: response })),
              catchError((e) => {
                this.alert.error(e?.error?.message || this.translation.pt('views.globals.an-error-occurred'));
                return of(
                  ApplicationModulesActions.loadApplicationModulesFailure({
                    error: e?.error?.message || this.translation.pt('views.globals.an-error-occurred'),
                    key,
                  }),
                );
              }),
            );
          }),
        );
      }),
    ),
  );

  refreshApplicationModules$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ApplicationModulesActions.refreshApplicationModules),
      map(() => ApplicationModulesActions.resetApplicationModules()),
    ),
  );
}
